import styled from "styled-components";
import { TextBlock, TextBlockHeading, Flex ,HR} from "./Common";



const Tech = styled.div`
  width: 82%;
  margin: auto;
`;



const BoxDiv = styled.div`
  text-align: center;
  width: 220px;
  
`;

const SkillBox = styled.div`
  box-shadow: 0px 12px 24px rgb(2 30 84 / 10%);
  margin: 20px;
  width: 150px;
  height: 100px;
  margin-bottom: 100px;
`;

const IMG = styled.img`
  object-fit: contain;
  width: 100px;
  height: 100px;
`;

const H1 = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: -50px;
  margin-top: 30px;
`;

const SkillBoxP = styled.div`
  margin: 20px;
  width: 300px;
  height: 100px;
  margin-bottom: 70px;
`;

const BoxDivP = styled.div`

  text-align: center;
  width: 300px;
`;

export default function Skills() {
  const data = [
    {
      src: "https://img.icons8.com/color/48/000000/html-5.png",
      name: "HTML 5",
    },
    { src: "https://img.icons8.com/color/48/000000/css3.png", name: "CSS 3" },
    {
      src: "https://img.icons8.com/color/48/000000/javascript.png",
      name: "JAVASCRIPT",
    },
    { src: "Images/reactjs.webp", name: "REACT JS" },
    {
      src: "https://upload.wikimedia.org/wikipedia/commons/4/49/Redux.png",
      name: "REDUX",
    },
    {
      src: "https://img.icons8.com/color/48/000000/nodejs.png",
      name: "NODE JS",
    },
    { src: "Images/mongodb.webp", name: "MONGO DB" },
    { src: "Images/express.webp", name: "EXPRESS" },
    { src: "https://img.icons8.com/color/48/000000/git.png", name: "GIT" },
  ];

  const proficencydata = [
    {
      src: "Images/frontend.webp",
      name: "Frontend",
    },
    { src: "Images/ds.webp", name: "Data Structures & Algorithms" },
    {
      src: "Images/backend.webp",
      name: "Backend",
    },
  ];

  return (
    <>
      <Tech>
        <HR />
        <TextBlockHeading>
          {" "}
          <H1>Tools I Use </H1>
        </TextBlockHeading>
        <Flex>
          {data.map((el, id) => (
            <BoxDiv key={id} className="stack-item">
              <SkillBox>
                <IMG src={el.src} alt={el.name} className="logo" />
                <TextBlock>{el.name}</TextBlock>
              </SkillBox>
            </BoxDiv>
          ))}
        </Flex>

        <HR />

        <TextBlockHeading>
          {" "}
          <H1>Proficiency</H1>
        </TextBlockHeading>
        <Flex>
          {proficencydata.map((el, id) => (
            <BoxDivP key={id} className="stack-item">
              <SkillBoxP>
                <IMG src={el.src} alt={el.name} className="logo" />
                <TextBlock>{el.name}</TextBlock>
              </SkillBoxP>
            </BoxDivP>
          ))}
        </Flex>
      </Tech>
    </>
  );
}

